// InitPage.js
import React from "react";
import i18n from "i18next";
import onInitImg from "../../public/assets/on_init.gif";
import { useDeviceStore } from "../stores/useDeviceStore";

const InitPage = () => {
  const isMobile = useDeviceStore((state) => state.isMobile);
  return (
    <div
      style={{
        height: "100vh",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        backgroundColor: "#FDFDFD", // 可按需替换背景色
        padding: "20px",
        boxSizing: "border-box",
      }}
    >
      {/* 第一行：Loading 动画 */}
      <img
        src={onInitImg}
        alt="Loading..."
        style={{
          width: isMobile ? "50%" : "15vw", // 宽度占 15% 屏幕宽
        }}
      />

      {/* 第二行：标题 */}
      <div
        style={{
          fontSize: "40px",
          fontWeight: "400",
          color: "#333",
          marginBottom: "10px",
        }}
      >
        {i18n.t("init.holdTight")}
      </div>

      {/* 第三行：副标题说明 */}
      <div
        style={{
          fontSize: "18px",
          color: "#999",
          lineHeight: 1.5,
        }}
      >
        {i18n.t("init.organizingMsg")}
      </div>
    </div>
  );
};

export default InitPage;
